<template>
  <div>
    <h2>{{ $t('title.preregistrations') }}</h2>

    <el-select
      filterable
      remote
      :remote-method="filterControllers"
      v-model="selectedControllerId"
    >

      <el-option
        v-for="item in filterControllers()"
        :key="item.value"
        :label="$t(item.label)"
        :value="item.value"
      />

    </el-select>

    <el-button
      v-if="hasPermission('CREATE_PREREGISTRATION')"
      :disabled="!selectedControllerId"
      type="primary"
      icon="plus"
      @click="addNew">{{ $t('button.new') }}</el-button>

    <data-table
      model="preregistrations"
      :columns="['contact_name', 'controllerName', 'regcode']"
      :operations="operations" />

    <el-dialog
      :title="$t('title.remove')"
      :visible="!!modelToDelete"
      width="30%"
      :before-close="() => { modelToDelete = null }">
      <span>{{ $t('remove.message') }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modelToDelete = null">{{ $t('button.cancel') }}</el-button>
        <el-button type="primary" @click="deleteModel">{{ $t('button.confirm') }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import findAll from 'service/findAll'
import DataTable from 'components/DataTable'
import { PREREGISTRATIONS_EDIT, PREREGISTRATIONS_CREATE } from 'router/routes'

export default {
  name: 'preregistration-list',
  data () {
    return {
      selectedControllerId: null,
      modelToDelete: null
    }
  },
  computed: {
    operations () {
      return [
        {
          label: 'edit',
          icon: 'edit',
          permission: 'EDIT_PREREGISTRATION',
          method: (model) => this.$router.push({ name: PREREGISTRATIONS_EDIT, params: { 'preregId': model.id } })
        },
        {
          label: 'delete',
          type: 'danger',
          icon: 'delete',
          permission: 'DELETE_PREREGISTRATION',
          method: (model) => (this.modelToDelete = model)
        }
      ]
    }
  },
  methods: {
    filterControllers (query) {
      return this.controllers
        .map(c => ({ label: c.name, value: c.id }))
        .filter(c => c.label.toLowerCase().includes((query || '').toLowerCase()))
    },
    addNew () {
      this.$router.push({ name: PREREGISTRATIONS_CREATE, params: { 'controllerId': this.selectedControllerId } })
    },
    deleteModel () {
      this.$store.dispatch(`preregistrations/delete`, this.modelToDelete)
      this.modelToDelete = null
    }
  },
  components: { DataTable },
  mixins: [
    findAll('preregistrations'),
    findAll('controllers', {
      filter: c => c.connected
    })
  ]
}
</script>


// WEBPACK FOOTER //
// PreregistrationList.vue?2e1a30bf